import React from "react";
import EditOrder from "../EditOrder";
import CloseOrder from "../CloseOrder";

// Edit / Close buttons are only available while an order is still open
export default function OrderActions({ singleOrder }) {
  const status = singleOrder?.status;
  if (status !== "unassigned" && status !== "assigned") return null;

  return (
    <div className="d-flex">
      <EditOrder order_data={singleOrder} order_status={status} />
      <CloseOrder order_data={singleOrder} order_status={status} />
    </div>
  );
}
